exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-container{display:flex;align-items:center;margin-bottom:10px}.styled-checkbox{width:20px;height:20px;margin-right:10px;appearance:none;border:2px solid #333;border-radius:4px;outline:none;cursor:pointer}.styled-checkbox:checked{background-color:#002b49;border:2px solid #002b49}label{padding-left:5px}.column-section{width:100%;display:inline-block;vertical-align:top;margin-right:20px}.draggable{width:48%;margin-right:1%;float:left;cursor:grab;padding:10px;border:1px solid #ccc;margin-bottom:5px}.draggable:active{cursor:grabbing}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62a03572","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/viewReports.vue
// module id = 1648
// module chunks = 0